import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function handleSupabaseResponse<T>(response: {
  data: T | null;
  error: { message: string } | null;
}): T {
  if (response.error) {
    throw new Error(response.error.message);
  }
  if (response.data === null) {
    throw new Error('No data returned');
  }
  return response.data;
}
